// extracted by mini-css-extract-plugin
module.exports = {"RecordTable":"AuditLogsDetail_RecordTable__3Ym58"};